import React, { useContext, useEffect, useState } from "react";
import { Spinner } from "../../components/Spinner";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faUserCheck, faUser } from "@fortawesome/free-solid-svg-icons";
import { SocketContext } from "../../context/SocketContext";
import moment from "moment";
import 'moment/locale/es-mx';


export const SessionUsuarios = () => {

    useCeo({
        title: "ADMINISTRACIÓN DE SESSIÓN DE USUARIOS",
        description: "Página de administración de sessión de usuarios",
    });

    const [loading, setLoading] = useState(false);
    const [encargadosOnline, setEncargadosOnline] = useState([]);
    const [encargadosOffline, setEncargadosOffline] = useState([]);
    const { socket } = useContext(SocketContext);

    useEffect(() => {
      if(!socket) return;
      socket.on("staffing_encargado", () => {
        loadInfo();
      });
      return () => {
        socket.off('staffing_encargado');
    }
    }, [socket]);

    useEffect(() => {
      loadInfo();
    }, []);

    const {
      getMonitoristas
    } = useUnidades();

    const loadInfo = async() => {
      setLoading(true);
      const statusEncargados = await getMonitoristas();
      if(statusEncargados.ok){
        setEncargadosOnline(statusEncargados.encargados_online);
        setEncargadosOffline(statusEncargados.encargados_offline);        
      }
      setLoading(false);
      
    }

    return (
        <>
            {loading && <Spinner />}
            <div className="container">
              <div className="row">
                  <div className="card col-12" style={{ padding: "10px" }}>
                      <div className="row">
                      {
                        encargadosOnline && encargadosOnline.map((persona)=>{
                        
                          return(
                              <>
                                <div className="card col-6 monitorista">
                                  <div className="row">
                                    <div className="col-12">
                                      <i>{ persona.name }</i>
                                    </div>
                                    <div className="col-6">
                                      <i>{ persona.cedi.nombre_cedis }</i>
                                    </div>
                                    <div className="col-6">
                                      <i>
                                        { persona.cat_tipo_registro.tipo_registro ? "En linea": "" }
                                      </i>
                                      { 
                                        <FontAwesomeIcon icon={ faUserCheck } className={ "Icon-"+persona.cat_tipo_registro.tipo_registro } />
                                      }
                                      
                                    </div>
                                  </div>
                                  
                                </div>
                              </>
                          )
                          
                        })
                      }
                      {
                        encargadosOffline && encargadosOffline.map((persona)=>{
                        
                          return(
                              <>
                                <div className="card col-6 monitorista">
                                  <div className="row">
                                    <div className="col-12">
                                      <i>{ persona.name }</i>
                                    </div>
                                    <div className="col-6">
                                      <i>{ persona.cedi.nombre_cedis }</i>
                                    </div>
                                    <div className="col-6">
                                      
                                          <i>
                                          { persona.cat_tipo_registro.tipo_registro ? "Desconectado": "" }
                                          </i>
                                       
                                          { 
                                          <FontAwesomeIcon icon={ faUserCheck } className={ "Icon-"+persona.cat_tipo_registro.tipo_registro } />
                                          }
                                        
                                      
                                    </div>
                                    <div className="col-12">
                                      <i style={{ fontWeight: "lighter"}}>
                                        {
                                          `Ultima conexión: `+ moment(persona.updatedAt).format("lll")
                                        }
                                      </i>
                                    </div>
                                  </div>
                                  
                                </div>
                              </>
                          )
                          
                        })
                      }
                      </div>
                  </div>
              </div>
            </div>
        </>
    )

}